/**
 * Hook for Google Drive Cache preloading
 */

import { useCallback } from "react";
import { useGoogleDriveCache } from "./useGoogleDriveCache";
import type { PreloadConfig } from "@/lib/services/google-drive-preloader";

export function useGoogleDriveCachePreload() {
  const cache = useGoogleDriveCache();

  const startPreload = useCallback(
    async (accessToken: string) => {
      return cache.startPreload(accessToken);
    },
    [cache]
  );

  const stopPreload = useCallback(() => {
    cache.stopPreload();
  }, [cache]);

  const getStatus = useCallback(() => {
    return cache.getPreloadStatus();
  }, [cache]);

  const updateConfig = useCallback((config: Partial<PreloadConfig>) => {
    cache.setPreloadConfig(config);
  }, [cache]);

  return {
    startPreload,
    stopPreload,
    getStatus,
    updateConfig,
  };
}
